import { render, staticRenderFns } from "./DiagnosesIcon.vue?vue&type=template&id=0b219562&scoped=true"
import script from "./DiagnosesIcon.vue?vue&type=script&lang=js"
export * from "./DiagnosesIcon.vue?vue&type=script&lang=js"
import style0 from "./DiagnosesIcon.vue?vue&type=style&index=0&id=0b219562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b219562",
  null
  
)

export default component.exports